export default {
  name: [
    v => !!v || 'Nazwa jest wymagana',
    v => (v && v.length >= 2) || 'Nazwa musi mieć co najmniej 2 znaków',
    v => (v && v.length <= 255) || 'Nazwa może mieć maksymalnie 255 znaków',
  ],
}